import { useSnackbar } from "notistack";
import { useMutation, useQuery } from "react-query";
import { useNavigate } from "react-router-dom";

import {
  BaseQueryProps,
  BaseSearchQueryProps,
  ListResponseData,
  Ranch,
  RanchInput,
} from "../types";
import {
  handleDelete,
  handleDetail,
  handleList,
  handleMutationError,
  handleQueryError,
  handleSave,
  handleSearch,
} from "./handler";

const methods = {
  useSearch: ({ query }: BaseSearchQueryProps) => {
    const navigate = useNavigate();
    return useQuery<Ranch[]>({
      queryKey: ["ranches", query],
      queryFn: () => handleSearch({ baseUrl: "ranches", query }),
      onError: handleQueryError(navigate),
    });
  },
  useSave: (ranchInput: RanchInput) => {
    const navigate = useNavigate();
    return useMutation<Ranch>({
      mutationFn: () => handleSave({ baseUrl: "ranches", input: ranchInput }),
      onError: handleQueryError(navigate),
      retry: 1,
    });
  },
  useList: ({ order, orderBy, page, query }: BaseQueryProps<Ranch>) => {
    const navigate = useNavigate();
    return useQuery<ListResponseData<Ranch>>({
      cacheTime: 0,
      queryKey: ["ranches", order, orderBy, page, query],
      queryFn: () =>
        handleList({ baseUrl: "ranches", order, orderBy, page, query }),
      onError: handleQueryError(navigate),
    });
  },
  useDetail: (id: string | undefined) => {
    const navigate = useNavigate();
    return useQuery<Ranch>({
      cacheTime: 0,
      queryKey: ["ranch", id],
      queryFn: () => handleDetail({ baseUrl: "ranches", id }),
      onError: handleQueryError(navigate),
    });
  },
  useDelete: (id?: number) => {
    const { enqueueSnackbar } = useSnackbar();
    return useMutation<Ranch>({
      mutationFn: () => handleDelete({ baseUrl: "ranches", id }),
      retry: 1,
      onError: handleMutationError(enqueueSnackbar),
    });
  },
};

export default methods;
